import { render, staticRenderFns } from "./edu-coppa-dialog.vue?vue&type=template&id=6768afb6"
import script from "./edu-coppa-dialog.vue?vue&type=script&lang=js"
export * from "./edu-coppa-dialog.vue?vue&type=script&lang=js"
import style0 from "./edu-coppa-dialog.vue?vue&type=style&index=0&id=6768afb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports